import { Component } from 'react';
import * as Highcharts from 'highcharts';
import style from './donut.scss';

interface State {
  dataWithColor: any[];
}

class DonutChart extends Component<any, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      dataWithColor: [],
    };
  }

  public componentDidMount() {
    this.renderChart();
  }

  public renderChart() {
    const chart = new Highcharts.Chart({
      chart: {
        renderTo: 'donutContainer',
        type: 'pie',
      },
      title: {
        text: '',
      },
      plotOptions: {
        series: {
          dataLabels: {
            enabled: false,
          },
        },
      },
      tooltip: {
        headerFormat: '',
        pointFormat:
          '<span>{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>',
      },
      credits: {
        enabled: false,
      },

      series: [
        {
          innerSize: '60%',
          data: this.props.data,
        },
      ],
    });

    this.setState({ dataWithColor: chart.series[0].data });
  }

  public getDataList() {
    const { dataWithColor } = this.state;
    return (
      <div>
        {dataWithColor &&
          dataWithColor.map(el => {
            return (
              <div className="lil-flex lil-py-4 lil-pr-12 lil-justify-between sm:lil-pr-0">
                <div>
                  <span
                    className={`${style['dot']}`}
                    style={{ background: el.color }}
                  ></span>
                  <span className="lil-pl-6 lil-font-semibold">{el.name}</span>
                </div>
                <div>
                  <span className="lil-font-semibold">{el.y}%</span>
                </div>
              </div>
            );
          })}
      </div>
    );
  }

  public render() {
    return (
      <div className="lil-flex lil-items-center lil-my-6 lil-py-6 lil-justify-items-center lil-rounded-xxl lil-shadow-md sm:lil-flex-col sm:lil-pt-0">
        <div className="lil-w-1/2 sm:lil-w-full">
          <div
            id="donutContainer"
            className="lil-mx-auto"
            style={{ height: '400px', width: '90%' }}
          ></div>
        </div>
        <div className="lil-w-1/2 lil-pl-12 sm:lil-px-6 sm:lil-w-full">
          {this.getDataList()}
        </div>
      </div>
    );
  }
}

export default DonutChart;



// WEBPACK FOOTER //
// ./components/common/donut/donutChart.tsx